import React from "react";
import Icon from "./Icon";

/**
 * Les trois états que chaque écran doit couvrir : chargement, vide, erreur.
 * Regroupés ici pour qu'ils restent visuellement identiques d'un écran à l'autre.
 */

export const LoadingRows = ({ rows = 5, height = 52 }) => (
  <div style={{ padding: "16px 22px", display: "flex", flexDirection: "column", gap: 10 }}>
    {Array.from({ length: rows }).map((_, index) => (
      <div key={index} className="mgr-skel" style={{ height }} />
    ))}
  </div>
);

export const LoadingCard = ({ height = 140 }) => (
  <div className="mgr-skel" style={{ height, borderRadius: 22 }} />
);

export const EmptyState = ({ title, hint }) => (
  <div className="mgr-state">
    <div className="mgr-state-title">{title}</div>
    {hint ? <div>{hint}</div> : null}
  </div>
);

export const ErrorState = ({ message, onRetry, retryLabel }) => (
  <div className="mgr-error">
    <Icon name="alert-circle" style={{ fontSize: 20, flexShrink: 0 }} />
    <span style={{ flex: 1 }}>{message}</span>
    {onRetry ? (
      <button type="button" className="mgr-link" onClick={onRetry}>
        {retryLabel}
      </button>
    ) : null}
  </div>
);
